import { Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[iriroMarkAsInvalid]',
  standalone: true,
})
export class MarkAsInvalidDirective {

  iriroMarkAsInvalid = input.required<boolean | null>();

  renderer2 = inject(Renderer2);
  el = inject(ElementRef);

  constructor() {

    effect(() => {
      if (this.iriroMarkAsInvalid() ) {
        this.renderer2.addClass(this.el.nativeElement, 'invalid');
      }
      else {
        this.renderer2.removeClass(this.el.nativeElement, 'invalid');
      }
    });
  }

}
